module.exports = __webpack_public_path__ + "img/banner-features-mobile.877f8875.jpg";